
import React from 'react';
import { SearchX, Home, Archive } from 'lucide-react';

interface EmptyStateProps {
  onReset: () => void;
  viewMode?: 'grid' | 'feed' | 'archive' | 'compact';
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onReset, viewMode }) => {
  const isArchive = viewMode === 'archive';

  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center animate-in fade-in slide-in-from-bottom-4 duration-700">
      <div className="relative mb-8">
        <div className="w-32 h-32 bg-gray-50 dark:bg-zinc-900 rounded-full flex items-center justify-center border border-gray-100 dark:border-zinc-800">
          {isArchive ? (
            <Archive className="w-12 h-12 text-gray-300 dark:text-zinc-700 stroke-[1.5]" />
          ) : (
            <SearchX className="w-12 h-12 text-gray-300 dark:text-zinc-700 stroke-[1.5]" />
          )}
        </div>
        <div className="absolute -bottom-2 -right-2 w-12 h-12 bg-white dark:bg-zinc-800 rounded-full flex items-center justify-center shadow-xl border border-gray-100 dark:border-zinc-700">
          <Home className="w-5 h-5 text-blue-500" />
        </div>
      </div>
      
      <h3 className="text-xl font-black text-gray-900 dark:text-white tracking-tight mb-2 uppercase">
        {isArchive ? 'Your Archive is Empty' : 'No Properties Found'}
      </h3>
      <p className="text-sm font-medium text-gray-400 dark:text-zinc-500 max-w-[280px] mb-8 leading-relaxed">
        {isArchive 
          ? "Listings you unpublish from your feed will appear here. You can restore them anytime." 
          : "We couldn't find any listings matching your current filters. Try adjusting your search."
        }
      </p>
      
      <button 
        onClick={onReset}
        className="px-8 py-3 bg-black dark:bg-white text-white dark:text-black rounded-xl font-black text-xs uppercase tracking-widest hover:opacity-90 active:scale-95 transition-all shadow-xl shadow-black/10"
      >
        {isArchive ? 'Return to Feed' : 'View All Listings'}
      </button>
    </div>
  );
};
